// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TCreateCatalogItemReq } from '../types/requests';

export function CatalogController() {
  const getCatalogNextTraining = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/catalog/items/scenarios`, {
      headers: getAuthHeaders(),
    });
  };

  const getCatalogItems = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/catalog/items/`, {
      headers: getAuthHeaders(),
    });
  };

  const getCatalogItemsCollections = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/catalog/items/collections`, {
      headers: getAuthHeaders(),
    });
  };

  const createCatalogItems = async <T>(data: TCreateCatalogItemReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/api/v1/catalog/items/`, data, {
      headers: getAuthHeaders(),
    });
  };

  const deleteCatalogItem = async <T>(item_id: string): Promise<T> => {
    return await axios.delete(`${DEV_APP_API_URL}/api/v1/catalog/items/${item_id}`, {
      headers: getAuthHeaders(),
    });
  };

  const updateCatalogItem = async <T>({ item_id, data }: {item_id: string, data: any;}): Promise<T> => {
    return await axios.patch(`${DEV_APP_API_URL}/api/v1/catalog/items/${item_id}`, data, {
      headers: getAuthHeaders(),
    });
  };

  return { getCatalogNextTraining, getCatalogItems, getCatalogItemsCollections, createCatalogItems, deleteCatalogItem, updateCatalogItem };
}
